import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { TID } from '../constants/testIds';

export default function Insights() {
    const { data } = useQuery({
        queryKey: ['insights'],
        queryFn: async () => (await api.get('/articles')).data,
    });
    const articles = data?.items || [];

    return (
        <div>
            <section className="border-b border-neutral-200">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-14 pb-12">
                    <div className="overline">Insights</div>
                    <h1 className="font-editorial text-[44px] lg:text-[68px] tracking-editorial mt-4 leading-[1.02]">
                        The neighbourhood, decoded.
                    </h1>
                    <p className="mt-6 text-[15px] text-neutral-600 max-w-2xl">
                        Long-form analysis on the forces shaping Canadian neighbourhoods. Data first. Opinions cautious. Never listings.
                    </p>
                </div>
            </section>

            <section>
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-0 border-l border-t border-neutral-200">
                    {articles.map((a) => (
                        <Link key={a.slug} to={`/insights/${a.slug}`} data-testid={TID.insights.card}
                            className="border-r border-b border-neutral-200 hover:bg-[#F7F7F5]">
                            <div className="aspect-[16/9] bg-neutral-100 overflow-hidden">
                                <img src={a.hero} alt={a.title} className="w-full h-full object-cover" loading="lazy" />
                            </div>
                            <div className="p-8">
                                <div className="overline">{a.category} · {a.read_min} min read · {a.published_at}</div>
                                <div className="font-editorial text-[30px] mt-6 leading-tight tracking-editorial">{a.title}</div>
                                <div className="mt-4 text-[14.5px] text-neutral-600 leading-relaxed line-clamp-3">{a.dek}</div>
                                <div className="mt-6 text-[12px] uppercase tracking-[0.18em] text-neutral-500">Read →</div>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </div>
    );
}
